var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTradingOptions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92 92",
    style: {
      enableBackground: "new 0 0 92 92"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;}\n\t.st1{fill:#262824;}\n\t.st2{fill:#1A1818;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "logo-trading-options"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(0 0.001)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st1",
    d: "M92,45.9l-64.7-1.4l64.2,8.2l-63.8-11L90,59.4L28.5,39l58.9,26.9L29.8,36.5L84,71.8 L31.3,34.2l48.4,43l-46.5-45l41.5,49.7L35.4,30.4L69,85.7L37.8,29l25,59.7L40.5,27.9l15.7,62.8l-13-63.4l6.2,64.4 L46,27.1l-3.4,64.6l6.2-64.4l-13,63.4l15.7-62.8L29.2,88.7l25-59.7L23,85.7l33.6-55.3L17.3,81.8l41.5-49.7l-46.5,45 l48.4-43L8,71.8l54.2-35.3L4.6,65.9L63.5,39L2,59.4l62.3-17.7l-63.8,11l64.2-8.2L0,45.9l64.7,1.4L0.5,39.1l63.8,11 L2,32.3l61.4,20.4L4.6,25.9l57.7,29.4L8,19.9l52.6,37.7l-48.4-43l46.5,45.1L17.3,9.9l39.3,51.4L23,6l31.2,56.7l-25-59.7 l22.3,60.8L35.8,1l13,63.4L42.6,0L46,64.6L49.4,0l-6.2,64.4L56.2,1L40.5,63.8L62.8,3.1l-25,59.7L69,6.1L35.4,61.4 L74.7,9.9L33.2,59.6l46.5-45l-48.4,43L84,19.9L29.8,55.3l57.7-29.4L28.5,52.7L90,32.3L27.7,50l63.8-11l-64.2,8.2L92,45.9 z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st2",
    d: "M47.1,32.5l0.2,29.8c0,0,8.5-10,17.4-9.1l0.7-33.8l-6.2,5.4c-2.7,2.4-5.7,4.4-8.8,6 L47.1,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st2",
    d: "M66.9,25.6l3.3-0.2v30.9c0,0-17.4,2.7-19.9,6c0,0,3.5-6.4,16.1-7.5L66.9,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st2",
    d: "M71.6,28h3.7l-0.1,35.2l-22.7-0.1c5.8-3.6,12.6-5.1,19.4-4L71.6,28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    className: "st2",
    d: "M25.1,25.6l-3.3-0.2v30.9c0,0,17.4,2.7,19.9,6c0,0-3.5-6.4-16.1-7.5L25.1,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    className: "st2",
    d: "M20.4,28h-3.7l0.1,35.2l22.7-0.1c-5.8-3.6-12.6-5.1-19.4-4L20.4,28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "st2",
    d: "M44.9,33.1c0,0-2.9-9.3-17.6-10.5v30.5c0,0,9.6,0.2,17.6,9.1V33.1z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTradingOptions);
export default __webpack_public_path__ + "static/media/logo-trading-options.2e94351ac3fa9e40009f0665cb45d58d.svg";
export { ForwardRef as ReactComponent };